import { useEffect, useState, useRef } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { _TAB_INPUT_SALES } from "../../../utils/constants";
import TableInputSaleAggVolume from "./TableInputSaleAggVolume";

const TableInputSalesAgg = ({
  params,
  rows,
  setRows,
  siteData,
  oldInternalVolume,
  setOldInternalVolume,
  gridRef,
}) => {
  const [tab, setTab] = useState(0);
  const priceId = useRef(null);

  useEffect(() => {
    setTab(0);
  }, [params]);

  const renderComponent = (tab) => {
    return (
      <TableInputSaleAggVolume
        params={params}
        rows={rows}
        setRows={setRows}
        tab={tab}
        siteData={siteData}
        oldInternalVolume={oldInternalVolume}
        setOldInternalVolume={setOldInternalVolume}
        priceId={priceId}
        gridRef={gridRef}
      />
    );
  };

  return (
    <Box>
      <Tabs value={tab} onChange={(_, newValue) => setTab(newValue)}>
        <Tab label="Volume" />
        <Tab label="Value" />
      </Tabs>
      {tab === 0 && renderComponent(_TAB_INPUT_SALES.VOLUME)}
      {tab === 1 && renderComponent(_TAB_INPUT_SALES.VALUE)}
    </Box>
  );
};

export default TableInputSalesAgg;
